import React from 'react';
import {Card} from '@mui/material';
import {Field} from 'formik';
import {TextField} from 'formik-mui';

export default function EntryThreeEdit() {
  return (
    <Card className={'box-shadow'} sx={{p: 4}}>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Condition'}
             name={`catalogue.condition`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Storage Location'}
             name={`catalogue.location`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Place of Origin'}
             name={`catalogue.place_of_origin`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Additional Information'}
             name={`catalogue.other_info`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Exhibition History'}
             name={`catalogue.exhibition_history`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Justification'}
             name={`justification`} multiline rows={3} autoFocus
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
    </Card>
  );
}